import { useContext } from 'react';
import { inputAutocompleteContext } from './context';

export const useInputAutocomplete = () => {
  const autocomplete = useContext(inputAutocompleteContext);
  return autocomplete;
};
